// extracted by mini-css-extract-plugin
module.exports = {"surveyLayout":"SurveyLayout_surveyLayout__ClDK8"};